import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { FontText, BookStats } from '../common';
import { useTranslation } from 'react-i18next';
import { generateBookRating } from '../../utils/bookUtils';

interface BookDisplayProps {
  book: {
    id: number;
    title: string;
    picture: string | null;
    chapter_count: number;
    author?: string;
  };
  chapter: {
    number: number;
    title: string;
  };
  readers: number;
  showStats?: boolean;
}

export const BookDisplay: React.FC<BookDisplayProps> = ({
  book,
  chapter,
  readers,
  showStats = true,
}) => {
  const { theme } = useTheme();
  const { t } = useTranslation();

  const { rating, ratingCount } = generateBookRating(book.id);

  const styles: Record<string, React.CSSProperties> = {
    container: {
      maxWidth: 800,
      margin: '0 auto',
      padding: '40px 20px 0',
    },
    bookHeader: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginBottom: '40px',
    },
    bookDetailCover: {
      width: 100,
      height: 150,
      objectFit: 'cover',
      borderRadius: 8,
      boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
      marginBottom: 20,
    },
    bookDetailTitle: {
      color: theme.colors.text,
      textAlign: 'center',
      marginBottom: '6px',
      margin: 0,
    },
    bookDetailAuthor: {
      color: theme.colors.textSecondary,
      textAlign: 'center',
      marginBottom: '10px',
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.bookHeader}>
        {book.picture && (
          <img
            src={book.picture}
            alt={book.title}
            style={styles.bookDetailCover}
          />
        )}
        <FontText h3 style={styles.bookDetailTitle}>
          {book.title}
        </FontText>
        {book.author && (
          <FontText small style={styles.bookDetailAuthor}>
            {t('by')} {book.author}
          </FontText>
        )}
      </div>

      {showStats && (
        <BookStats
          readers={readers}
          chapters={book.chapter_count}
          rating={rating}
          ratingCount={ratingCount}
        />
      )}
    </div>
  );
};
